import React from 'react';

const AppFooter = () => {

    return (
        <div className="layout-footer">
            <div className="footer-logo-container">
                <img id="footer-logo" src="assets/layout/images/favicon-2.png" alt="Sistema" />
                <span className="app-name">PRELAFITFINDER</span>
            </div>
            <span className="copyright">&#169; Prelafit - {new Date().getFullYear()}</span>
        </div>
    );
}

export default AppFooter;
